import service from './service';
import { API_URL_CLOUD } from '../config/config';

export const getSektorBisnisApi = () => {
    return service.extGet(`${API_URL_CLOUD}/business_sector`);
};

export const getRatingApi = () => {
    return service.extGet(`${API_URL_CLOUD}/rating`);
};